import { FC, useEffect, useState } from "react";
import { Button } from "elements";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import * as Styled from "./styled";

import { ReactComponent as LockIcon } from "./assets/lock.svg";
import { ReactComponent as CopyIcon } from "./assets/copy.svg";

import DuplicateModal from "../../../components/duplicateModal";

interface IProps {
  id: string;
  isCloning: boolean;
}

const ViewOnly: FC<IProps> = ({ id, isCloning }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [duplicateModal, setDuplicateModal] = useState(false);

  const {
    user: { data: userData },
    // @ts-ignore
  } = useSelector((state) => state.auth);

  const userId =
    userData?.external_accounts?.find(
      (account: any) => account.decision_and_project
    )?.decision_and_project ?? null;

  useEffect(() => {
    if (isCloning && id && userId) {
      setDuplicateModal(true);
    }
  }, [isCloning, id, userId]);

  const handleClick = () => {
    setDuplicateModal(true);
  };

  const handleDuplicateModal = () => {
    setDuplicateModal(false);
  };

  return (
    <>
      <DuplicateModal
        visible={duplicateModal}
        handleCloseModal={handleDuplicateModal}
      />

      <Styled.Wrapper>
        <Styled.Container>
          <Styled.Col>
            <LockIcon />
            <Styled.Title>View Only</Styled.Title>
          </Styled.Col>

          <Button onClick={handleClick}>
            <CopyIcon />
            Make a copy
          </Button>
        </Styled.Container>
      </Styled.Wrapper>
    </>
  );
};

export default ViewOnly;
